export default __webpack_public_path__ + "static/media/logo.14f38630.svg";